import { LEGACY_AUTH_CONSTANT } from '@bvt-features/auth/redux';
import { dataMenu } from '../constant';
import { MAINMAP_MAP_MODULEBAR_CONSTANT } from './MAINMAP_MAP_MODULEBAR_CONSTANT';

const initialState = {
  menu_list: dataMenu,
  menu_selected: {},
  submenu_list: [],
  submenu_selected: {},
};

export function MAINMAP_MAP_MODULEBAR_REDUCER(state = initialState, action) {
  let returnData = state;
  Object.values(MAINMAP_MAP_MODULEBAR_CONSTANT).map((ctx) => {
    if (action.type === MAINMAP_MAP_MODULEBAR_CONSTANT.RESET_STATUS) {
      returnData = {
        ...returnData,
        status_GET: 'IDLE',
        message: ' ',
      };
    } else if (
      action.type === MAINMAP_MAP_MODULEBAR_CONSTANT.MODULE_BAR_RESET_STATE
    ) {
      returnData = { ...initialState };
    } else if (action.type === LEGACY_AUTH_CONSTANT.UNAUTHORIZED) {
      returnData = { ...initialState };
    } else if (ctx === action.type && !ctx.includes('[NO_STATE_UPDATE]')) {
      returnData = { ...returnData, ...action.payload };
    }
    return null;
  });

  return returnData;
}
